import { ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { BKJSideModal } from 'components/BKJSideModal/BKJSideModal';
import { useJaneDetailsModalUIContext } from './JaneDetailsModal.ui.context';
import { JaneDetailsModalHeaderMap } from './JaneDetailsModal.constants';
import { janeDetailsModalRoutingService } from './JaneDetailsModal.constants';
import { FC } from 'react';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export const JaneDetailsModalTemplate: FC = ({ children }) => {
  const { isOpen, janeDetailsModalActiveModalView } = useJaneDetailsModalUIContext();

  return (
    <>
      <BKJSideModal
        isOpen={isOpen}
        onClose={() => janeDetailsModalRoutingService.close()}
        headerComponent={
          JaneDetailsModalHeaderMap[
            janeDetailsModalActiveModalView as keyof typeof JaneDetailsModalHeaderMap
          ]
        }
        data-testid="J360JaneDetailsModal"
        showBackButton={janeDetailsModalRoutingService.isBackButtonVisible()}
        onBack={janeDetailsModalRoutingService.goToPrevView}
      >
        <ErrorBoundary
          componentName="JaneDetailsModal"
          showLogo={!WhiteLabelAccessor.isWhiteLabelled()}
        >
          <>{children}</>
        </ErrorBoundary>
      </BKJSideModal>
    </>
  );
};
